export default __webpack_public_path__ + "img/8506e01c03bf786df184d129a8f653e0.png";